import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useOccContext } from '../../../../../context/occ/hooks/use-occ-context';
import { Icon } from '../../../../icon/icon';
import { PasswordRuleStatus } from '../types/password-rule-status';
const b = bemClassBuilder('v-password-rule-checker-rule');
export const PasswordRuleCheckerRule = observer(props => {
    const { assets: occAssets } = useOccContext();
    const { rule, status } = props;
    return (_jsxs("li", Object.assign({ className: b.block({ status }) }, { children: [_jsx(Icon, { className: b.element('icon', { [status]: true }), name: getIconNameForRuleStatus(status, occAssets) }), rule.displayText] })));
});
PasswordRuleCheckerRule.displayName = 'PasswordRuleCheckerRule';
const getIconNameForRuleStatus = (status, occAssets) => {
    switch (status) {
        case PasswordRuleStatus.Invalid:
            return occAssets.passwordRuleCheckerInvalidIconName;
        case PasswordRuleStatus.Valid:
            return occAssets.passwordRuleCheckerSuccessIconName;
        default:
            return occAssets.passwordRuleCheckerInitialIconName;
    }
};
